const commonTheme = {
  main_palette: {
    light1: '#99E9BA',
    light2: '#00C853',
    main: '#00A526',
    dark: '#00801D'
  },
  gray_palette: {
    light1: '#F9FAFB',
    light2: '#ECEFF1',
    normal1: '#B0BEC5',
    normal2: '#78909C',
    dark1: '#546E7A',
    dark2: '#37474F'
  },
  dark_palette: {
    light1: '#2E2E2E',
    light2: '#2C2C2C',
    normal1: '#272727',
    normal2: '#212121',
    dark1: '#E1E1E1',
    dark2: '#121212'
  },
  support_palette: {
    blue: '#039BE5',
    light_blue: 'rgba(3, 155, 229, 0.2)',
    green: '#4CAF50',
    light_green: 'rgba(76, 175, 80, 0.25)',
    yellow: '#FFCA28',
    light_yellow: ' rgba(255, 202, 40, 0.2)',
    red: '#F44336',
    light_red: 'rgba(244, 67, 54, 0.2)',
    white: '#FFFFFF',
    black: '#000000',
    disabled: 'rgba(0, 0, 0, 0.26)'
  },
  safevideo: {
    light: '#37474F',
    main: '#37474F',
    dark: '#102027',
  }
}

export default commonTheme;